import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#slider" }),
    /*#__PURE__*/_createTextVNode(" Slider ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Drag the slider within a fixed range. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicUsage = _resolveComponent("EUIBasicUsage")
  const _component_EUIDiscreteValues = _resolveComponent("EUIDiscreteValues")
  const _component_EUISliderWithInputBox = _resolveComponent("EUISliderWithInputBox")
  const _component_EUIRangeSelection = _resolveComponent("EUIRangeSelection")
  const _component_EUIVerticalMode = _resolveComponent("EUIVerticalMode")
  const _component_EUIShowMarks = _resolveComponent("EUIShowMarks")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicUsage),
    _createVNode(_component_EUIDiscreteValues),
    _createVNode(_component_EUISliderWithInputBox),
    _createVNode(_component_EUIRangeSelection),
    _createVNode(_component_EUIVerticalMode),
    _createVNode(_component_EUIShowMarks)
  ], 64))
}